import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import DoneIcon from '@material-ui/icons/Done';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CustomRadioTypes, defaulfCustomRadionType } from 'Common/Types/Types';

const useStyles = makeStyles({
	root: {
		color: '#1dabb8',
		background: 'white',
		width: 14,
		height: 14,
		border: '.5px solid',
		margin: '0 .2rem',
		fontSize: '12px',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	icon: {
		borderRadius: '50%',
		width: 16,
		height: 16,
		fontSize: '12px',
		boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
		backgroundColor: '#f5f8fa',
		backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
		'$root.Mui-focusVisible &': {
			outline: '2px auto rgba(19,124,189,.6)',
			outlineOffset: 2,
		},
		'input:hover ~ &': {
			backgroundColor: '#ebf1f5',
		},
		'input:disabled ~ &': {
			boxShadow: 'none',
			background: 'rgba(206,217,224,.5)',
		},
	},
	checkedIcon: {
		fontSize: '12px',
	},
	title: {
		padding: '0 1rem 0 0',
		margin: '0',
	},
});

// Inspired by blueprintjs
interface StyleRadioProps extends RadioProps {
	active?: any;
}
const StyledRadio = (props: StyleRadioProps) => {
	const classes = useStyles();
	const [checked, setChecked] = useState(false);
	const [active, setActive] = useState(1);
	const selectedIcon = () => {
		setChecked(!checked);
		setActive(props?.active);
		// eslint-disable-next-line no-console
		console.log('I have been clicked', props);
	};
	const onChange = (e: any) => {
		// eslint-disable-next-line no-console
		console.log('on change', e.currentTarget.value);
		if (e.currentTarget.value === props.value) {
			setChecked(!checked);
		}
	};
	return (
		<Radio
			className={classes.root}
			// defaultValue={props.value === 'boy' ? 'boy' : 'girl'}
			// defaultChecked={props.value === 'boy' ? true : false}
			disableRipple
			color="default"
			// onClick={selectedIcon}
			// onChange={onChange}
			// checked={checked}
			checkedIcon={<DoneIcon className={classes.checkedIcon} />}
			icon={<span className={classes.icon} />}
			{...props}
		/>
	);
};
// className={clsx(classes.icon, classes.checkedIcon)}
const CustomRadio = ({
	items,
	defaultValue,
	genderChoice,
	componentWidth,
	onGenderUpdate,
	childId,
}: CustomRadioTypes) => {
	const classes = useStyles();
	// eslint-disable-next-line no-console
	console.log(defaultValue);
	const setGestationValue = (value: string) => {
		onGenderUpdate && onGenderUpdate(value, childId && childId);
		genderChoice(value.toLocaleUpperCase());
	};
	return (
		<Fragment>
			<section
				className={`d-flex flex-nowrap justify-content-evenly align-items-center  ${
					componentWidth ? 'w-50' : 'w-100'
				}`}
			>
				<p className={classes.title}> Gender</p>
				<RadioGroup
					defaultValue={defaultValue ? defaultValue : 'girl'}
					aria-label="gender"
					name="customized-radios"
					className="d-flex flex-nowrap justify-content-around flex-row w-100"
				>
					<FormControlLabel
						value="girl"
						control={<StyledRadio />}
						label="Girl"
						onClick={() => setGestationValue('girl')}
					/>
					<FormControlLabel
						value="boy"
						control={<StyledRadio />}
						label="Boy"
						onClick={() => setGestationValue('boy')}
					/>
				</RadioGroup>
			</section>
		</Fragment>
	);
};

export default CustomRadio;
